import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class InMemoryCacheService<T = any> {

    private storage: { [key: string]: BehaviorSubject<T | null> } = {};

    public set(key: string, value: T | null) {
        if (!this.storage[key]) {
            this.storage[key] = new BehaviorSubject<T | null>(value);
            return;
        }
        this.storage[key].next(value);
    }

    public get(key: string) {
        if (!this.storage[key]) {
            this.storage[key] = new BehaviorSubject<T | null>(null);
        }
        return this.storage[key];
    }
}
